import React, { useCallback, useMemo } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import ReactGA from 'react-ga';

// Material-UI imports
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Third-party library imports
import { Box } from 'reflexbox';

// Local component imports
import FirebaseWrapper from "./components/helpers/FirebaseWrapper";
import RequestAlertBar from "./components/common/RequestAlertBar";
import Routing from './components/Routing';

// Utility/helper imports
import { nativeApi } from './components/expo/NativeAPI';
import { useEventListener } from './helpers/helpers';
import CenteredSection from './components/helpers/CenteredSection';
import store from './redux/store';
import { getThemeOptions } from './components/helpers/ThemeSettings';
import { ColorModeProvider, useColorMode } from './components/helpers/ColorModeContext';

// Styles
import './App.css';

function AppMuiTheme({ children }) {
    const { mode } = useColorMode();
    const theme = useMemo(() => createTheme(getThemeOptions(mode)), [mode]);
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}

const TRACKING_ID = "UA-227551288-1"; //google analytics tracking ID
ReactGA.initialize(TRACKING_ID);

const App = () => {

    nativeApi.setStore(store);

    const onClick = useCallback(
        e => {
            let node = e.target;
            if(node?.localName !== 'a'){
                node = node.closest('a')
            }
            if (node) {
                if (
                    node.localName === 'a' &&
                    node.href &&
                    nativeApi.isNative &&
                    window.location.host !== e.target.host
                ) {
                    e.preventDefault();
                    e.stopPropagation();
                    nativeApi.openExternalLink(node.href);
                }
                return false;  // stop handling the click
            } else {
                return true;  // handle other clicks
            }

        },
        []
    );
    useEventListener("click", onClick);

    return (
        <Box style={{height: '100%'}}>
            <Provider store={store}>
                <ColorModeProvider>
                    <AppMuiTheme>
                        <FirebaseWrapper>
                            <CenteredSection>
                                <BrowserRouter>
                                    <Routing/>
                                    <RequestAlertBar/>
                                </BrowserRouter>
                            </CenteredSection>
                        </FirebaseWrapper>
                    </AppMuiTheme>
                </ColorModeProvider>
            </Provider>
        </Box>
    );
};

export default App
